export default {"src":"/_next/static/media/chartDashboard.74c74be5.svg","height":223,"width":706,"blurWidth":0,"blurHeight":0};